// extracted by mini-css-extract-plugin
export default {"urgentLow":"GraphUrgentLow_urgentLow__rMEPo"};